import { render, staticRenderFns } from "./MdSb.vue?vue&type=template&id=0f979b48&scoped=true"
import script from "./MdSb.vue?vue&type=script&lang=js"
export * from "./MdSb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f979b48",
  null
  
)

export default component.exports